import { useState } from "react";
import { Link } from "react-router-dom";

import { useCart } from "@/cart/CartContext";
import { Price } from "@/components/Price";
import { PaymentDialog } from "@/components/PaymentDialog";

export function Cart() {
  const { lines, setQty, remove, clear, count } = useCart();
  const [paying, setPaying] = useState(false);
  const currency = lines[0]?.currency ?? "USD";
  const subtotal = lines.reduce((n, l) => n + l.price_cents * l.quantity, 0);

  if (count === 0) {
    return (
      <div className="mx-auto max-w-2xl">
        <h1 className="text-2xl font-extrabold tracking-tight text-ink">Your cart</h1>
        <div className="mt-4 rounded-2xl border border-line bg-surface p-10 text-center shadow-card">
          <p className="text-ink-soft">Your cart is empty.</p>
          <Link
            to="/"
            className="mt-4 inline-block rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-white hover:bg-brand-strong"
          >
            Browse the catalog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="text-2xl font-extrabold tracking-tight text-ink">Your cart</h1>
      <div className="mt-4 space-y-3">
        {lines.map((l) => (
          <div
            key={l.sku_code}
            className="flex items-center justify-between rounded-xl border border-line bg-surface p-4 shadow-card"
          >
            <div>
              <div className="font-semibold text-ink">{l.name}</div>
              <div className="text-sm text-ink-soft">
                <Price cents={l.price_cents} currency={l.currency} /> each
              </div>
            </div>
            <div className="flex items-center gap-3">
              <input
                type="number"
                min={1}
                value={l.quantity}
                onChange={(e) => setQty(l.sku_code, parseInt(e.target.value || "1", 10))}
                className="w-16 rounded-lg border border-line bg-surface px-2 py-1.5 text-right text-ink focus:border-brand focus:outline-none"
              />
              <button
                onClick={() => remove(l.sku_code)}
                className="text-sm text-ink-mute transition-colors hover:text-down"
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-center justify-between rounded-xl border border-line bg-surface p-5 shadow-card">
        <div className="text-sm text-ink-soft">
          Subtotal
          <div className="text-xl font-bold text-ink">
            <Price cents={subtotal} currency={currency} />
          </div>
          <span className="text-xs text-ink-mute">Final price confirmed at checkout</span>
        </div>
        <button
          onClick={() => setPaying(true)}
          className="rounded-lg bg-brand px-5 py-2.5 font-semibold text-white shadow-sm transition-colors hover:bg-brand-strong"
        >
          Checkout →
        </button>
      </div>

      <PaymentDialog
        open={paying}
        onClose={() => setPaying(false)}
        items={lines.map((l) => ({ sku_code: l.sku_code, quantity: l.quantity }))}
        title={`${count} item${count === 1 ? "" : "s"}`}
        totalCents={subtotal}
        currency={currency}
        onActivated={clear}
      />
    </div>
  );
}
